module.exports = __webpack_public_path__ + "img/theme11.1f8ed46f.png";